// Log idle hiếm (TONE §6.7, CULTIVATION §1.4): dòng lạ không ai nói, chen vào Hồi Sơn ≤ 1/tuần.
// Chỉ khai khóa i18n; chữ nằm trong src/i18n/vi.json. Không dùng dòng cài cắm có "lần đầu bắt buộc".
export const IDLE_RARE_LINE_KEYS: readonly string[] = [
  'log.idle.rare.ashWind',
  'log.idle.rare.ashYear',
  'log.idle.rare.elderDawn',
];
